export default {
  positive: 'Positivo',
  neutral: 'Neutro',
  negative: 'Negativo',
  notClassified: 'Não Classificado',
  showAllThemes: 'Todos os temas',
};
